//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { brandBriefUploadStore } from '@campaigns/hooks/brandBriefUploadStore';
import { contentInspirationUploadStore } from '@campaigns/hooks/contentInspirationUploadStore';

type CampaignRequestId = string | number;

export const isCampaignAssetUploadInProgress = (
  campaignRequestId: CampaignRequestId,
) =>
  contentInspirationUploadStore.getState(campaignRequestId)
    .pendingContentInspirationUploadCount > 0 ||
  brandBriefUploadStore.getState(campaignRequestId)
    .pendingBrandBriefFilename !== undefined;
